import { Box } from '@mui/material';
import { colorDarkGrey, colorPrimaryNavy, colorWhite } from 'customColors';
import React, { ReactElement } from 'react';

const onColor = colorPrimaryNavy;

export interface SwitchProps {
  disabled?: boolean;
  on?: boolean | undefined;
  onToggle: () => void;
}

export const Switch = ({
  disabled = false,
  on = false,
  onToggle,
}: SwitchProps): ReactElement => {
  return (
    <Box
          role="switch"
          aria-checked={on}
          aria-disabled={disabled}
          aria-label={'switch'}
          tabIndex={disabled ? -1 : 0}
          onClick={onToggle}
          onKeyDown={(e: React.KeyboardEvent) => {
            if (disabled) return;
            if (e.key === ' ' || e.key === 'Enter') {
              e.preventDefault();
              onToggle();
            }
          }}
          sx={{
            position: 'relative',
            width: 52,
            height: 32,
            borderRadius: '9999px',
            backgroundColor: on ? onColor : colorWhite,
            border: on ? 'none' : `2px solid ${colorDarkGrey}`,
            boxSizing: 'border-box',
            cursor: disabled ? 'default' : 'pointer',
            opacity: disabled ? 0.5 : 1,
            transition: 'background-color 0.2s ease, border-color 0.2s ease',
            outline: 'none',
            '&:focus-visible': {
              boxShadow: `0 0 0 2px ${onColor}`,
            },
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              transform: 'translateY(-50%)',
              left: on ? 'calc(100% - 20px - 4px)' : '4px',
              width: on ? 20 : 16,
              height: on ? 20 : 16,
              borderRadius: '9999px',
              backgroundColor: on ? colorWhite : colorDarkGrey,
              transition: 'left 0.2s ease, background-color 0.2s ease',
            }}
          />
        </Box>
  );
};
